import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  HostListener,
  Inject,
  AfterViewInit,
  ElementRef,
  ChangeDetectorRef,
} from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatBottomSheet } from '@angular/material/bottom-sheet';

import {
  catchError,
  distinctUntilChanged,
  filter,
  map,
  pairwise,
  switchMap,
  takeUntil,
  debounceTime,
} from 'rxjs/operators';
import {
  Router,
  Event,
  NavigationEnd,
  RoutesRecognized,
} from '@angular/router';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../environments/environment';
import { resolveHostedUrl } from './constants/hosted-api-urls';
import { global_app_settings } from './constants/global-app-settings';
import { ApiService } from './common/services/api.service';
import { UtilService } from 'src/app/util/util.service';
import { DOCUMENT } from '@angular/common';
import { CommonService } from './common/services/common.service';
import { ThemeService } from './common/theme/theme.service';
import { Theme, light, dark } from './common/theme/theme';
import { EasyEatHqService } from './common/services/ee-hq.service';

import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { AnimationItem } from 'lottie-web';
import { AnimationOptions } from 'ngx-lottie';
import { CommonSocketService } from 'src/app/common/services/common-socket.service';
import { LocalStorageService } from './common/services/localStorage.service';
import { PusherEventService } from './common/services/pusher-event.service';
import { SidenavComponent } from './common/sidenav/sidenav.component';
import { ModernSidenavComponent } from './common/sidenav/components/modern-sidenav/modern-sidenav.component';
import { Event as EventList, MType } from 'src/app/pusher-event';
import { interval, of, Subject } from 'rxjs';
import { OrderReactEventService } from './order/order-reactevent.service';
import { OrderStateService } from './order/order-state.service';
import { WebSocketService } from './web-socket.service';
import { REACTEVENTS } from 'src/app/react-events';
import { SentryService } from './common/services/sentry.service';
import { TokenLoginService } from './common/services/token-login.service';
import { PrintService } from './common/services/print.service';
import { TimezoneService } from './common/services/timezone.service';
import { LanguageService } from './common/services/language.service';
import { TranslateService } from '@ngx-translate/core';
import { country } from './common/enums/language';
import { OrderCountService } from './common/services/order-count.service';
import { SystemLockService } from './common/services/system-lock.service';
import { DuesLockService } from './common/services/dues-lock.service';
import { NudgeService } from './common/services/nudge.service';
import { RnRedirectionRoutes } from 'src/app/common/enums/rnRedirectionList';
declare function send_data(params: string): any;
import { MENU_2, TABLE_BOOKING_PENDING_WARN, TABLE_BOOKING_PENDING_CLOSE } from 'src/defaultImages.js';
import { MetaDataServiceService } from './util/meta-data-service.service';
import { EventTrackerService } from './common/services/event-tracker.service';
import { NzModalService } from 'ng-zorro-antd/modal';
import { PineLabService } from './common/services/pine-lab.service';
import { AudioService } from './common/services/audio.service';
import { CollectionInfrastructureHelperService } from './collection-infrastructure/collection-infrastructure-helper.service';
import { ORDER_BY } from './order/platform.constant';
import { TableBookingHelperService } from './table-bookings/services/table-bookings-helper.service';
import { TableBookingApiService } from './table-bookings/services/table-bookings-api.service';
import { DateService } from './common/services/date.service';
import { TABLE_BOOKINGS_STATUS_ENUM } from './table-bookings/enums/table-bookings.enum';
import { SyncService } from './common/services/sync-service.service';
import dayjs from 'dayjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('sideNavRef', { static: false }) sideNavRef: ModernSidenavComponent;
  @ViewChild('dummyButton', { static: false }) dummyButton: ElementRef;
  images = {
    MENU_2: MENU_2,
    TABLE_BOOKING_PENDING_WARN,
    TABLE_BOOKING_PENDING_CLOSE
  };
  metadata: { title: string; description: string; keywords: string };

  title = 'partner-app';
  clickCount = 0;
  isUserLoggedIn = false;
  isValidated: boolean = false;
  user_type = '';
  user_name = '';
  restaurant_name = '';
  restaurant_id: string;
  negativeBalance:boolean=false
  id : string = '';
  reason = '';
  public currentUrl: string;
  public noOfNewOrders: number;
  isMobile: boolean = false;
  innerWidth: number;
  languageFromUrl;
  countryFromUrl;
  languageEnum = { en: 'en_US', id: 'id_ID' };
  currToken = '';
  deviceId: string = '';
  activeRoute: string;
  showSideNav: boolean;
  private activeTheme: Theme = light;
  invoke_counter = 0;
  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date = null;
  countdown = 20;
  analyticsData: any = [];
  eeTotalEarnings: number;
  isIdle = 0;
  isIdleWarning = 0;
  options: AnimationOptions = {
    path:
      environment.aws_s3_bucket_url +
      '/partner-app/assets/lottie/lock_timeout.json',
  };

  isProduction: boolean = environment.production;
  hideSidenav: boolean;
  webViewAllowedRoutes = [
    '/reports',
    '/tableservice',
    '/tables',
    '/menu',
    '/analytics',
    '/section-counters',
    '/inventory',
    '/discounts',
    '/help-center',
  ];
  private ngUnsubscribe = new Subject();
  getActiveOrder$ = new Subject<any>();
  isFoodCourtViewEnabled: boolean = false;
  timerInterval;
  isAutoRefreshEnabled: boolean = false;
  printFromDevice: boolean = true;
  showHamburger: boolean = false;
  allTableBookings: Array<any> = [];
  resvIdsToWarn: Array<any> = [];
  showResvWarnPopup: boolean = false;

  showHQLoanBanner:boolean = false;
  isRealmDevice: boolean = false;
  isMobileSidenavOpen: boolean = false;
  constructor(
    private dialog: MatDialog,
    private router: Router,
    private httpClient: HttpClient,
    private apiService: ApiService,
    private utilService: UtilService,
    @Inject(DOCUMENT) private doc: any,
    private commonService: CommonService,
    private themeService: ThemeService,
    public hqService: EasyEatHqService,
    private idle: Idle,
    private _bottomSheet: MatBottomSheet,
    private _commonSocket: CommonSocketService,
    private _pusherEvent: PusherEventService,
    private _localStorage: LocalStorageService,
    private _orderReactEvent: OrderReactEventService,
    private _orderState: OrderStateService,
    private _wsService: WebSocketService,
    public translateService: TranslateService,
    public languageService: LanguageService,
    public timezoneService: TimezoneService,
    private _tokenLogin: TokenLoginService,
    private _printService: PrintService,
    private _orderCountService: OrderCountService,
    private _cdr: ChangeDetectorRef,
    private _sentryService: SentryService,
    private metadataService: MetaDataServiceService,
    private _eventTracker: EventTrackerService,
    private _modalService: NzModalService,
    private _pineLabService: PineLabService,
    private _ciHelperService: CollectionInfrastructureHelperService,
    private _audioService: AudioService,
    private _tbHelperService: TableBookingHelperService,
    private _tbApiService: TableBookingApiService,
    private _dateService: DateService,
    private _syncService: SyncService,
    private _systemLockService: SystemLockService,
    private _duesLockService: DuesLockService,
    private _nudgeService: NudgeService
  ) {
    this._sentryService.initSentry();
    this.onResize();
    router.events.subscribe((event: Event) => this.url_changed(event));
    this._localStorage.statusChanged$.subscribe((isLoggedIn) => {
      if (!isLoggedIn) this.logout();
    });


    this.listenRNAppNavigationEvent();
    this.printFromDevice = this.utilService.getPrintFromDevice()
  }

  ngOnInit() {
    const page = 'home';
    this.metadata = this.metadataService.getMetadata(page);
    this.updateMetaTag();
    const offline = 'checkOffline';
    const params = {
      device_id: this.utilService.getDeviceUID(),
    };
    if (this.utilService.lastActive() && !this.isRealmEnabled()) {
      this.utilService.startPolling(
        offline,
        this.utilService.lastActiveInterval(),
        params,
        true
      );
    }
    //--------Set language according to domain----------
    // this.redirectionService.getRedirectionLink();
    this.languageService.setCountryData();
    this.translateService.addLangs(['en_US', 'id_ID']);
    this.translateService.setDefaultLang(
      localStorage.getItem('language') || 'en_US'
    );
    this.languageService.setDialCode(
      this.languageService.getDialCode() || country.ai.dialCode
    );
    this.checkCurrPrevRoutes();
    this.setTheme();
    this._printService.itStarted = true;
    this._printService.isReactDevice = !!(
      localStorage.getItem('is_react') === '1'
    );
    this._localStorage.watch('restaurant_settings').subscribe((_) => {
      this.utilService.isKiosk();
    });
    this.loadRazorScript();
    this._localStorage.set('showHamburger', true);
    this.watchHamburgerState();
    this.getAllTableBookings();
  }


  ngAfterViewInit() {
    // Subscribing to pusher events in Rest admin login
    this._localStorage
      .watch('restaurant_id')
      .pipe(distinctUntilChanged())
      .subscribe((value) => {
        this.getAnalytics();
        this._printService.print_rest_Id = value;
        this._orderCountService.restaurant_id = value;
        this.isFoodCourtViewEnabled = !!JSON.parse(
          this._localStorage.get('fc_rest_ids')
        );
        if (value && !this.hqService.isHqUser() && !this.isFoodCourtViewEnabled)
          this._commonSocket.initSocketForPOS();
        else this._commonSocket.disconnectSocket();
      });

    // Subscribing multiple foodcourt restaurants for experimental purpose
    this._localStorage
      .watch('fc_rest_ids')
      .pipe(distinctUntilChanged())
      .subscribe((value) => {
        if (value && !this.hqService.isHqUser()) {
          let fc_rest_ids = JSON.parse(this._localStorage.get('fc_rest_ids'));
          if ((fc_rest_ids || []).length) {
            this._commonSocket.disconnectSocket();
            this._commonSocket.initSocketForMultipleChannels(fc_rest_ids);
          }
        } else this._commonSocket.disconnectSocket();
      });

    // Start subscription to multiple foodcourt outlets in HQ if show_order_dashboard setting present
    this._localStorage
      .watch('hq_settings')
      .pipe(distinctUntilChanged())
      .subscribe((value) => {
        if (value && this.hqService.isHQActive) {
          let fcOrderDashBoardShow = !!((JSON.parse(
            localStorage.getItem('hq_settings')
          ) || {})['global'] || {})['show_order_dashboard'];
          this._commonSocket.disconnectSocket();
          if (fcOrderDashBoardShow) {
            let allHQOutletsList = (this.hqService.hqOutletsList || []).map(
              (item) => item['id']
            );
            this._commonSocket.initSocketForMultipleChannels(allHQOutletsList);
          }
          this._commonSocket.initSocketForHQ();
        } else this._commonSocket.disconnectSocket();
      });

    /*calling pusher event watch method*/
    this.watchPusherEvents();
    this._localStorage.watch('restaurant_settings')
      .pipe(
        distinctUntilChanged(),
        debounceTime(1000),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe((value) => {
        this.showHQLoanBanner =
          global_app_settings.enable_loan_feature &&
          this.hqService.isHqUser() &&
          this.languageService.getCountry() === country.ai.country;
        this._orderReactEvent.updateAutoAcceptValues();
        this._orderReactEvent.computePrepaidOrderSetting();
        if (value && value !== 'undefined') {
          this._printService.print_rest_settings = JSON.parse(value);
          this.checkAutoRefreshActive();
          this.utilService.isSocketPrintEnabled() && this._wsService.connect();
          this._orderCountService.isOrderSyncSettingActive &&
            this._orderCountService.startPolling();
        } else {
          this.endPollingInterval();
          this._orderCountService.endPolling();
          this._wsService.closeWebSocket();
        }

        // Update Sentry user details with throttling
        this._sentryService.setUserDetails({
          id: !this.hqService.isHqUser()
            ? this.restaurant_id
            : this._localStorage.get('hq_id'),
          restaurantId: this.restaurant_id,
          restaurantName: this.restaurant_name,
          hqId: this._localStorage.get('hq_id'),
          hqName: this._localStorage.get('ee_mall_name'),
        });
        this._cdr.detectChanges();
      });

    let el: HTMLElement = this.dummyButton.nativeElement;
    el.click();

    this.fetchAllOrdersSubscription();
  }

  watchHamburgerState() {
    this._localStorage.watch('showHamburger').subscribe((_) => {
      this.showHamburger = JSON.parse(this._localStorage.get('showHamburger') || 'false');
    });
  }

  private updateMetaTag() {
    const titleMeta = document.getElementById('titleMeta');
    const descriptionMeta = document.getElementById('descriptionMeta');
    const keywordsMeta = document.getElementById('keywordsMeta');

    titleMeta.setAttribute('content', this.metadata.title);
    descriptionMeta.setAttribute('content', this.metadata.description);
    keywordsMeta.setAttribute('content', this.metadata.keywords);
  }

  checkLockScreen() {
    let lock_time = this.utilService.lockScreenTime();
    if (!this.hqService.isHqUser() && this.utilService.isLockEnabled()) {
      this.idle.setIdle(lock_time['idle']);
      this.idle.setTimeout(lock_time['timeout']);
      this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

      this.idle.onIdleEnd.subscribe(() => {
        this.idleState = 'No longer idle.';
        this.reset();
      });
      this.idle.onTimeout.subscribe(() => {
        this.idleState = 'Timed out!';
        this.timedOut = true;
        this.isIdleWarning = 0;
        this.router.navigate(['/lock']);
      });
      this.idle.onIdleStart.subscribe(() => {
        this.idleState = "You've gone idle!";
        this.isIdle = 1;
        this.isIdleWarning = 0;
      });
      this.idle.onTimeoutWarning.subscribe((countdown) => {
        try {
          this.dialog.closeAll();
          this._modalService.closeAll()
          this._bottomSheet.dismiss();
        } catch {}
        this.isIdleWarning = 1;
        this.countdown = countdown;
      });
      this.reset();
    }
  }

  reset() {
    this.idle.watch();
    this.idleState = 'Started.';
    this.timedOut = false;
    this.isIdle = 0;
    this.isIdleWarning = 0;
  }

  animationCreated(animationItem: AnimationItem): void {}
  url_changed(event) {
    if (event instanceof NavigationEnd) {
      this.refreshOldToken();
      this.activeRoute = event.url;
      if (
        this.router.parseUrl(this.router.url)['queryParams']['hideSidebar'] ===
          'true' ||
        this.router.parseUrl(this.router.url)['hideSidebar'] === '1'
      ) {
        this._localStorage.set('hideSideNav', 1);
        this.hideSidenav = true;
      } else if (
        this.router.parseUrl(this.router.url)['queryParams']['hideSidebar'] ===
          'false' ||
        this.router.parseUrl(this.router.url)['hideSidebar'] === '0'
      ) {
        this._localStorage.set('hideSideNav', 0);
        this.hideSidenav = false;
      }
      if (
        this.router.parseUrl(this.router.url)['queryParams'][
          'isRealmEnabled'
        ] === 'true' ||
        this.router.parseUrl(this.router.url)['isRealmEnabled'] === '1' ||
        this._localStorage.get('isRealmEnabled') === '1'
      ) {
        this._localStorage.set('isRealmEnabled', 1);
      }
      if (
        this.router.parseUrl(this.router.url)['queryParams'][
          'isRealmEnabled'
        ] === 'false' ||
        this.router.parseUrl(this.router.url)['isRealmEnabled'] === '0'
      ) {
        this._localStorage.set('isRealmEnabled', 0);
      }
      if (event.urlAfterRedirects?.includes('/pos/settle')) {
        this.syncPaymentInitiatedOnSettleLanding();
      }
      this.checkUrl();
      this.close();
    }
  }

  private syncPaymentInitiatedOnSettleLanding(): void {
    const restaurantId = this._localStorage.get('restaurant_id');
    const queryOrderId =
      this.router.parseUrl(this.router.url)['queryParams']?.order_id;
    const isCentralCashier = !!this.utilService.isKiosk();
    const orderId = isCentralCashier
      ? this._localStorage.get('pos_order_id') || queryOrderId
      : queryOrderId || this._localStorage.get('pos_order_id');
    if (!restaurantId || !orderId) {
      return;
    }
    this._syncService
      .syncPaymentInitiateState(
        restaurantId,
        orderId,
        {},
        isCentralCashier ? 'fc_order' : 'order'
      )
      .subscribe(() => {}, () => {});
  }

  close() {
    this.closeMobileSidenav();
  }

  isMposRoute(): boolean {
    const route = this.activeRoute || '';
    return (
      route.includes('/pos-mobile/menu') ||
      route.includes('/pos-mobile/cart') ||
      route.includes('/pos-mobile/payment')
    );
  }

  openMobileSidenav() {
    this.isMobileSidenavOpen = true;
  }

  closeMobileSidenav() {
    this.isMobileSidenavOpen = false;
  }

  // remove this code after all token is updated for all restaurant
  refreshOldToken() {
    try {
      let curr_token = localStorage.getItem('token');
      if (curr_token.indexOf('.') === -1) {
        this.updateToken();
      } else {
        // no need to refresh token
      }
    } catch (error) {}
  }
  updateToken() {
    const payload = {
      restaurant_id: localStorage.getItem('restaurant_id'),
      staff_cred: environment.temp_pin,
      refresh_token: 1,
    };
    this.apiService.verifyStaff(payload).subscribe(
      (response) => {
        if (response.status == 1) {
          localStorage.setItem('hq_id', response.hq_id);
          localStorage.setItem('token', response.token);
        }
      },
      (error) => {}
    );
  }

  checkUrl() {
    const urlTree = this.router.parseUrl(this.router.url);
    const isValidUrl = this.router.url.includes('/orders');
    const queryParams = urlTree.queryParams;
    const isValidHQUrl = this.router.url.includes('/hq/dashboard');
    let urlFragments = this.router.url.split('?');
    let isWebViewAllowedRoutes = this.webViewAllowedRoutes.includes(
      urlFragments[0]
    );
    /*
      Check whether url has valid rest_admin login token
    */
    if (
      (queryParams.token !== undefined && isValidUrl) ||
      (queryParams.token && isWebViewAllowedRoutes)
    ) {
      this.currToken = queryParams.token;
      this.restaurant_id = queryParams.rest_id;
      this.languageFromUrl = this.languageEnum[queryParams.lang];
      this.countryFromUrl = queryParams.country;
      this.deviceId = queryParams.device_id;
      if (this.languageFromUrl && this.countryFromUrl) {
        this.languageService.setCountryData(
          this.languageFromUrl,
          this.countryFromUrl
        );
      }
      localStorage.setItem('ee_user_type', 'rest_admin');
      localStorage.setItem('token', this.currToken);
      if (this.deviceId) {
        this._localStorage.set('deviceId', this.deviceId);
      }
      // localStorage.setItem("restaurant_id", this.restaurant_id);
      this._localStorage.set('restaurant_id', this.restaurant_id);
      localStorage.setItem('hq_id', queryParams.hq_id);
      if (queryParams.rn !== undefined) {
        if (queryParams.rn) {
          localStorage.setItem('is_react', '1');
          this._printService.isReactDevice = true;
        }
      }
      if (queryParams.printV2FromRN !== undefined) {
        this._printService.printV2FromRN = JSON.parse(queryParams.printV2FromRN);
      }
      if (queryParams.appVersion !== undefined) {
        this._printService.appVersion = queryParams.appVersion;
      }
      if (queryParams.admin && queryParams.admin == '1') {
        localStorage.setItem('is_admin', '1');
      } else localStorage.setItem('is_admin', '0');
      localStorage.setItem('tokenLogin', '1');
      // this.validateUser(this.currToken, isWebViewAllowedRoutes);

      /* Reactnative Foodcourt url login condition  */
      if (queryParams.fc_rest_ids && queryParams.fc_court_view) {
        try {
          let rest_ids = decodeURIComponent(queryParams.fc_rest_ids);
          let rest_ids_array = rest_ids.split(',');
          if ((rest_ids_array || []).length) {
            this._localStorage.set(
              'fc_rest_ids',
              JSON.stringify(rest_ids_array)
            );
            this._localStorage.set('fc_court_view', 1);
          }
        } catch {}
      }
      this.validateUser(this.currToken, isWebViewAllowedRoutes);
    } else if (
      /*
      Check whether url has valid rest_hq_admin login token
    */
      queryParams.token !== undefined &&
      queryParams.hq_id !== undefined &&
      // queryParams.outlets !== undefined &&
      isValidHQUrl
    ) {
      // let outlets = decodeURIComponent(queryParams.outlets);
      this.currToken = queryParams.token;
      // localStorage.setItem("ee_outlets", outlets);
      localStorage.setItem('token', queryParams.token);
      localStorage.setItem('hq_id', queryParams.hq_id);
      localStorage.setItem('ee_user_type', 'rest_hq_admin');
      localStorage.setItem('restaurant_name', queryParams.mall);
      this.themeService.setActiveTheme(dark);
      if (queryParams.rn !== undefined) {
        if (queryParams.rn) {
          localStorage.setItem('is_react', '1');
          this._printService.isReactDevice = true;
        }
      }
      if (queryParams.printV2FromRN !== undefined) {
        this._printService.printV2FromRN = JSON.parse(queryParams.printV2FromRN);
      }
      if (queryParams.appVersion !== undefined) {
        this._printService.appVersion = queryParams.appVersion;
      }
      if (queryParams.admin && queryParams.admin == '1') {
        localStorage.setItem('is_admin', '1');
      } else localStorage.setItem('is_admin', '0');
      this._tokenLogin.getHQTokenAccessDetails(queryParams.hq_id);
    } else if (
      queryParams.validity_token &&
      queryParams.type === 'hq_signup' &&
      this.router.url.split('?')[0] === '/hq/login'
    ) {
      this._localStorage.clear();
      this.router.navigate(['hq/login'], {
        queryParams: {
          type: 'hq_signup',
          validity_token: queryParams.validity_token,
        },
      });
    } else if (
      queryParams.validity_token &&
      queryParams.type === 'reset_password' &&
      queryParams.email &&
      this.router.url.split('?')[0] === '/hq/login'
    ) {
      this._localStorage.clear();
      this.router.navigate(['hq/login'], {
        queryParams: {
          type: 'reset_password',
          email: queryParams.email,
          validity_token: queryParams.validity_token,
        },
      });
    } else if (localStorage.getItem('token')) {
      this.currToken = localStorage.getItem('token');
      this.validateUser(this.currToken);
    } else {
      if (!this.router.url.includes('/login')) {
        this.logout();
        this.showSideNav = false;
      }
    }
  }

  validateUser(token, skipLockScreen?) {
    const formData: any = new FormData();
    formData.append('token', token);
    const nestURL = resolveHostedUrl('nestURL');
    this.httpClient
      .post(`${nestURL}/api/auth/v2/token`, formData)
      .pipe(
        map((res: any) => {
          // Unwrap enveloped Nest response to PHP shape
          if (res && typeof res === 'object' && typeof res.statusCode === 'number' && res.data && typeof res.data === 'object') {
            return res.data;
          }
          return res;
        })
      )
      .subscribe((data: any) => this.initUser(data, skipLockScreen));
    this.showSideNav = true;
  }

  initUser(data, skipLockScreen?) {
    if (data['status'] === 1) {
      this.invoke_counter++;
      this.isUserLoggedIn = true;
      this.user_type = data['data']['user_type'];
      this.user_name = data['data']['user_name'];
      this.restaurant_name = data['data']['restaurant_name'];
      this.restaurant_id = data['data']['restaurant_id'] || this._localStorage.get('restaurant_id');


      this._localStorage.set('token', this.currToken);
      localStorage.setItem('email', data['data']['login_email']);
      let isHqEnabled = this.hqService.isHqUser();
      // !isHqEnabled && localStorage.setItem("user_type", this.user_type);
      const user_role = data.data.user_role;
      // !isHqEnabled && localStorage.setItem("ee_user_type", user_role);
      if (!isHqEnabled) {
        localStorage.setItem('user_type', this.user_type);
        localStorage.setItem('ee_user_type', user_role);
        this._localStorage.set('restaurant_id', this.restaurant_id);
        localStorage.setItem('restaurant_name', this.restaurant_name);
      }
      if (user_role === 'rest_admin') this.themeService.setActiveTheme(light);
      else if (user_role === 'rest_hq_admin' || user_role === 'rest_hq_staff')
        this.themeService.setActiveTheme(dark);

      localStorage.setItem('user_name', this.user_name);
      localStorage.setItem('staff_user_id', data?.data?.user_id);
      this.getRestaurantDetails(this.restaurant_id)
        .then((res: any) => {
          const data = res;
          if(data && data.status && typeof data === 'object' && !data.ttl){
            data['ttl'] = Date.now() + 1000 * 60 * 30;
            this._localStorage.set('restaurant_details', JSON.stringify(data));
          }
          this.negativeBalance = ((res || {}).data || {}).negative_balance
          this._localStorage.set('negativeBalance', ((res || {}).data || {}).negative_balance || false)
          this.id = ((res || {}).data || {}).id
          this._cdr.detectChanges()
          localStorage.setItem('restaurant_address', ((res || {}).data || {}).address);
          if(res?.data?.curr_sym){
            this._localStorage.set('restaurant_currency', (res?.data?.curr_sym));
          }
          localStorage.setItem('restaurant_printer', this.utilService.getPrinterIp((res || {}).data));
          this._localStorage.set('default_bill_receipt_ip', ((res || {}).data || {}).printer);
          localStorage.setItem(
            'restaurant_dcode',
            JSON.stringify(res.data.dkick_code)
          );
          localStorage.setItem(
            'restaurant_location',
            JSON.stringify(res.data.location)
          );
          this._localStorage.set(
            'restaurant_phone',
            ((res || {}).data || {}).phone
          );
          localStorage.setItem('restaurant_type', res.data['type']);
          this._localStorage.set(
            'restaurant_settings',
            JSON.stringify(res.data.settings)
          );
          this._cdr.detectChanges();
          this._localStorage.set('restaurant_api_version', res.data.settings.global.api_version);
          localStorage.setItem('restaurant_logo', res.data.logo);
          localStorage.setItem('restaurant_nameid', res.data.nameid);
          (res.data || {}).foodcourt && this._localStorage.set('foodcourt', (res.data || {}).foodcourt);
          this.commonService.setRestaurantDataObs(res.data);
          if (this.invoke_counter === 1 && !skipLockScreen && !this.router.url.includes('/order-status')) {
            this.checkLockScreen();
          }
          if (
            this.router.url.includes('/lock') ||
            this.router.url.includes('/login') ||
            this.hqService.isHqUser()
          ) {
            this.idle.stop();
          } else {
            this.idle.stop();
            this.reset();
          }
        })
        /* POS-18027: resolve the dues partial lock before the first guarded
           navigation, so DuesLockGuardService can answer synchronously. */
        .then(() => this._duesLockService.resolve(this.restaurant_id))
        .then(() => {
          this.redirect_to_user_page(this.router.url, this.user_type);
        });
      this.isValidated = true;
      this._eventTracker.easyeat_track_event(this.restaurant_id, {
        user_type: this.user_type,
        restaurant_id: this.restaurant_id,
        restaurant_name: this.restaurant_name,
      });
    } else {
      this.logout();
      this.showSideNav = false;
      this.isValidated = false;
    }
  }

  async getRestaurantDetails(id: string) {
    try {
      const param = new FormData();
      param.append('restaurant_id', id);
      return this.apiService.getRestaurantDetails(param).toPromise();
    } catch (error) {
      console.error(error);
    }
  }

  watchPusherEvents() {
    /*Watching order events on socket (Pusher or RTC)*/
    this._commonSocket
      .watchEvent(EventList.ORDER_EVENT)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((event) => this.onPusherOrderEvent(event));

    this._commonSocket
      .watchEvent(EventList.TABLE_EVENT)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((event) => this.onPusherTableEvent(event));

    this._commonSocket
      .watchEvent(EventList.TABLE_RESERVATION_EVENT)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((event) => this.onPusherTableReservationEvent(event));
  }

  onPusherOrderEvent(message) {
    if (
      message['mtype'] === MType.ORDER_CONFIRMED &&
      message['data'] &&
      message['data']['platform'] == 'grabfood'
    ) {
      // const orderId = message['data']['order_id'];
      // const itr = message['data']['itr'];
      this._audioService.playAudioOnNewOrder(true);
      // if (this.printFromDevice) {
      //   this.utilService.sendPrintCommand(orderId, itr);
      // }
      try {
        this._eventTracker.easyeat_track_event(
          'GRAB_APP_COMPONENT_EVENT_PRINT',
          {
            message: message,
          }
        );
      } catch (e) {}
    }

    switch (message.mtype) {
      /* CASE: When Order Confirmed Message Type is received */
      case MType.ORDER_CONFIRMED:
        if (this.isAutoRefreshEnabled) {
          this._orderState.updateOrdersState(message, 'from_pusher');
        } else {
          const isAcceptableOrderBy = [ORDER_BY.MPOS, ORDER_BY.MM].includes(
            message?.data?.order_by
          );
          if (
            message?.data?.kiosk_order &&
            !this.utilService.isKiosk() &&
            isAcceptableOrderBy
          ) {
            const orderId = message?.data?.order_id;
            const itr = message?.data?.itr;
            if (this.printFromDevice) {
              this.utilService.sendPrintCommand(orderId, itr);
            }
          }
          if (
            !(
              (JSON.parse(localStorage.getItem('restaurant_settings')) || {})
                .global || {}
            ).print_v2_enabled && this.printFromDevice
          ) {
            this._orderReactEvent.triggerPrintEventForAutoAccept(message);
          }
        }

        this._orderReactEvent.sendAcceptDeclineOrderReact(
          (message.data || {}).order_id || null,
          REACTEVENTS.ORDER_ACCEPT,
          { itr: message.data.itr }
        );
        break;

      /* CASE: When Order Declined Message Type is received */
      case MType.ORDER_CANCELED:
        this._orderReactEvent.sendAcceptDeclineOrderReact(
          (message.data || {}).order_id || null,
          REACTEVENTS.ORDER_DECLINE,
          { itr: 1 }
        );
        break;

      case MType.ORDER_ITEM_DECLINED:
        this._orderReactEvent.sendAcceptDeclineOrderReact(
          (message.data || {}).order_id || null,
          REACTEVENTS.ORDER_DECLINE,
          { itr: message.data.declined_items_itr[0] }
        );
        break;

      case MType.PAYMENT_SUCCESS:
          this._pineLabService.isPineLabPmtSuccess((message || {}).data);
          break;
    }
  }

  onPusherTableEvent(message) {
    if (
      message['mtype'] === MType.USER_MESSAGE ||
      message['mtype'] === MType.PAYMENT_SUCCESS
    ) {
      if (message.data.service_type === 'collect cash') {
        this._orderReactEvent.sendAcceptDeclineOrderReact(
          (message.data || {}).order_id || null,
          REACTEVENTS.CASH_COLLECT,
          { table_no: message.data.table_no }
        );
      } else {
        this._orderReactEvent.sendAcceptDeclineOrderReact(
          (message.data || {}).order_id || null,
          REACTEVENTS.TABLE_EVENT,
          { table_no: message.data.table_no }
        );
      }
    }
    if(message && message['mtype'] === MType.TABLE_UPDATED && message.data && message.data.isUpdatedByUser){
      this.utilService.sendTransferTableComand(message.data.order_id);
    }
  }

  onPusherTableReservationEvent(message) {
    if (message['mtype'] === MType.RESV_LESS_THAN_5_MINS_REM) {
      this.getAllTableBookings();
    }
  }

  httpParamsForAllTableBookings(): HttpParams {
    const startEpoch = this._dateService.getCurrentEpoch();
    const statusParam = `${TABLE_BOOKINGS_STATUS_ENUM.PENDING},${TABLE_BOOKINGS_STATUS_ENUM.MODIFICATION_REQUESTED}`;
    return new HttpParams()
      .set('page_no', '1')
      .set('limit', '500')
      .set('start_epoch', startEpoch.toString())
      .set('status', statusParam);
  }

  getAllTableBookings() {
    const restaurant_id = this._localStorage.get('restaurant_id');
    const params = this.httpParamsForAllTableBookings();
    if(restaurant_id){
    this._tbApiService
      .getAllTableBookingOrders(restaurant_id, params)
      .subscribe(
        (res: any) => {
          this.allTableBookings = ((res || {}).data || {}).values || [];
          const tenMinutesAgoEpoch = dayjs().subtract(10, 'minutes').unix();
          this.resvIdsToWarn = this.allTableBookings
            .filter(
              (e) =>
                e.status == TABLE_BOOKINGS_STATUS_ENUM.PENDING &&
                e.startTimestamp <= tenMinutesAgoEpoch &&
                e.merchantAck != 1
            )
            .map((el) => el.id);
          this.showResvWarnPopup = this.resvIdsToWarn.length > 0;
        },
        (error) => {
          this._tbHelperService.apiErrorMsg(error);
        }
      );
    }
  }

  setTheme() {
    const theme = localStorage.getItem('ee_theme');
    if (theme) {
      this.activeTheme = theme === 'dark' ? dark : light;
    } else this.activeTheme = light;
    this.themeService.setActiveTheme(this.activeTheme);
  }
  checkCurrPrevRoutes() {
    this.router.events
      .pipe(
        filter((evt: any) => evt instanceof RoutesRecognized),
        pairwise()
      )
      .subscribe((events: RoutesRecognized[]) => {
        if (!events[0].urlAfterRedirects.includes('/menu')) {
          const data = {
            last_interaction_id: null,
            order_type: 0,
          };
          localStorage.setItem('menu_state', JSON.stringify(data));
        }
      });
  }
  @HostListener('window:resize', ['$event'])
  onResize(event?) {
    this.innerWidth = window.innerWidth;
    if (this.innerWidth < 768) this.isMobile = true;
    else {
      this.isMobile = false;
      this.isMobileSidenavOpen = false;
    }
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this._commonSocket?.disconnectSocket();
  }

  logout() {
    const user_type = localStorage.getItem('ee_user_type');
    this._ciHelperService.removeCollectionInfra();
    this._systemLockService.resetLockState();
    this._nudgeService.clearNudgeStorage();
    this._localStorage.clearSession();
    this.isUserLoggedIn = false;
    this.user_type = '';
    try {
      let data = { action: 'logout' };
      let x = JSON.stringify(data);
      send_data(x);
    } catch (error) {}
    if (user_type === 'rest_hq_admin' || user_type === 'rest_hq_staff') {
      this.router.navigateByUrl('/hq/login');
    } else {
      this.router.navigateByUrl('/login');
    }
  }

  isUsrLoggedIn() {
    if (localStorage.getItem('token')) {
      return true;
    } else {
      return false;
    }
  }

  get showSystemLock(): boolean {
    if (!this.isUsrLoggedIn() || this.hqService.isHqUser()) {
      return false;
    }
    const route = this.activeRoute || '';
    if (
      route.includes('/pending-payment') ||
      route === '/login' ||
      route === '/hq/login' ||
      route === '/lock'
    ) {
      return false;
    }
    const restSettings = this.utilService.getRestaurantSettings() || {};
    const isPosLocked = !!((restSettings.global || {}).is_pos_locked || 0);
    if (!isPosLocked) {
      return false;
    }
    return this.utilService.litePricing() || !this.negativeBalance;
  }

  isRealmEnabled() {
    return this._localStorage.get('isRealmEnabled') === '1';
  }

  get_user_type() {
    if (localStorage.getItem('token')) {
      return localStorage.getItem('user_type');
    } else {
      return '---';
    }
  }

  redirect_to_user_page(currentUrl, userType) {
   if (userType === 'MM') {
      if (
        currentUrl === '/seating' ||
        currentUrl === '/dashboard' ||
        currentUrl === '/menu' ||
        currentUrl === '/staff' ||
        currentUrl === '/sections' ||
        currentUrl === '/dishes' ||
        currentUrl.includes('/tables') ||
        currentUrl === '/counters' ||
        currentUrl === '/menudishes' ||
        currentUrl.includes('/restaurant') ||
        currentUrl === '/restaurant/restaurant-details' ||
        currentUrl === '/restaurant/charges' ||
        currentUrl === '/restaurant/commissions' ||
        currentUrl === '/tableservice' ||
        currentUrl.includes('/loyalty') ||
        currentUrl.includes('/pending-payment') ||
        currentUrl.includes('/payment-overdue') ||
        currentUrl === '/reports' ||
        currentUrl.includes('reports') ||
        currentUrl === '/pos' ||
        currentUrl.includes('/pos/order') ||
        currentUrl.includes('/pos/settle') ||
        currentUrl.includes('/pos/split-bill') ||
        currentUrl === '/orders' ||
        currentUrl === '/pos-mobile/menu' ||
        currentUrl === '/pos-mobile/cart' ||
        currentUrl === '/pos-mobile/payment' ||
        currentUrl.includes('/analytics') ||
        currentUrl.includes('/menu/dish/edit/') ||
        currentUrl.includes('menu/dish/add') ||
        currentUrl.includes('menu') ||
        currentUrl.includes('inventory') ||
        currentUrl.includes("settlement") ||
        currentUrl.includes('section-counters') ||
        currentUrl.includes('discounts') ||
        currentUrl.includes('staff-center') ||
        currentUrl.includes('register-services') ||
        currentUrl.includes('help-center') ||
        currentUrl.includes('hq/outlets') ||
        currentUrl.includes('hq/billing') ||
        currentUrl.includes('hq/reports') ||
        currentUrl.includes('hq/analytics') ||
        currentUrl.includes('hq/staff-center') ||
        currentUrl.includes('hq/settlement') ||
        currentUrl.includes('hq/loyaltyProgram') ||
        currentUrl.includes('hq/referralProgram') ||
        currentUrl.includes('hq/integrations') ||
        currentUrl.includes('hq/marketing') ||
        currentUrl.includes('hq/inventory') ||
        currentUrl.includes('hq/discounts') ||
        //  && !(currentUrl.includes("hq/login"))||
        currentUrl.includes('lock') ||
        currentUrl.includes('variantGroup/add/') ||
        currentUrl.includes('/restaurant') ||
        currentUrl.includes('/table-bookings') ||
        currentUrl.includes('/ai-insights') ||
        currentUrl.includes('hq/pending-orders') ||
        currentUrl === 'hq/no-permission' ||
        currentUrl.includes('e-invoice') ||
        currentUrl.includes('hq/customer-display') ||
        currentUrl.includes('hq/restaurant-setting') ||
        currentUrl.includes('hq/device-center')
      ) {
        this.router.navigateByUrl(currentUrl);
      } else {
        if (this.hqService.isHqUser()) {
          this.router.navigate(["/hq/dashboard"]);
        } else {
          if (this.router.url.includes('/order-status')) {
            return;
          } else if (
            localStorage.getItem('tokenLogin') &&
            this.utilService.isLockEnabled() &&
            this._localStorage.get('isRealmEnabled') !== '1'
          ) {
            this.router.navigate(['/lock']);
          } else this.router.navigate(['/orders']);
        }
      }
    }
  }

  playAudioOnInit(): void {
    this._audioService.playAudioOnInit();
  }
  isLoggedOut(event) {
    if (event == 'logout') this.showSideNav = false;
  }

  loadRazorScript(){
     try{
       new Promise((resolve) => {
        let node = document.createElement('script');
        node.src = environment.razorPayScript;
        node.type = 'text/javascript';
        node.defer = true;
        document.getElementsByTagName('head')[0].appendChild(node);
      });
     }catch(e){}
  }

  isSidebarCollapsed: boolean = false;
  toggleSidebarCollapse(ev) {
    this.isSidebarCollapsed = ev.isCollapsed;
  }

  /* Checking if order auto refresh is enabled and invoking the live orders polling */
  checkAutoRefreshActive() {
    this.isAutoRefreshEnabled = !!((JSON.parse(
      localStorage.getItem('restaurant_settings')
    ) || {})['global'] || {})['auto_refresh'];
    if (this.isAutoRefreshEnabled) {
      let refreshInterval =
        ((JSON.parse(localStorage.getItem('restaurant_settings')) || {})[
          'global'
        ] || {})['auto_refresh_interval'] || 10000;
      this.startgetAllOrdersPolling(refreshInterval);
    }
  }
  startgetAllOrdersPolling(delay) {
    if (!this.timerInterval) {
      this.timerInterval = interval(delay);
      this.timerInterval
        .pipe(
          takeUntil(this.ngUnsubscribe),
          filter(
            (_) =>
              !this.hqService.isHQActive &&
              !(
                this.activeRoute.includes('/orders') ||
                this.activeRoute.includes('/pos/settle') ||
                this.activeRoute === '/login' ||
                this.activeRoute.includes('/hq/login') ||
                this.activeRoute === '/'
              ) &&
              this.isAutoRefreshEnabled
          )
        )
        .subscribe((value) => this.getActiveOrder$.next(value));
    }
  }

  endPollingInterval() {
    try {
      this._orderState.currOrdersState = {};
      this.timerInterval.unsubscribe();
    } catch {}
  }

  fetchAllOrdersSubscription() {
    this.getActiveOrder$
      .pipe(
        takeUntil(this.ngUnsubscribe),
        switchMap(() =>
          this.apiService
            .getCurrentOrders(
              this.restaurant_id,
              '',
              '',
              this.isFoodCourtViewEnabled
                ? JSON.parse(localStorage.getItem('fc_rest_ids'))
                : [this.restaurant_id]
            )
            .pipe(
              catchError((err) =>
                of({
                  error: 'Not Found',
                  message: 'Something went wrong.',
                  statusCode: 404,
                })
              )
            )
        )
      )
      .subscribe(
        (response: any) => {
          if (response.statusCode === 200) {
            let allRunningOrders = this._orderState.filterAllRunningOrders(
              response.data || []
            );
            this._orderState.updateOrdersState(allRunningOrders);
          }
        },
        (error: any) => {}
      );
  }

  listenRNAppNavigationEvent() {
    window['getReactNativeRedirection'] = {
      getRNAppNavigateAction: (response: any) => {
        if (RnRedirectionRoutes.hasOwnProperty(response.rnAppNavigateAction)) {
          this.router.navigate([
            RnRedirectionRoutes[response.rnAppNavigateAction],
          ]);
        } else {
          // default route to redirect if nothing matches
          this.router.navigate([RnRedirectionRoutes.dashboard]);
        }
      },
    };
  }

  getAnalytics() {
    const lastExecutionDate = this._localStorage.get('lastExecutionDate');
    // // Get the current date
    const currentDate = new Date().toISOString().slice(0, 10);
    // Check if the function has not been executed today
    if (lastExecutionDate !== currentDate) {
      this.apiService
        .getAnalytics(this._localStorage.get('restaurant_id'))
        .subscribe(
          (response: any) => {
            if ((response || {}).status === 1) {
              this._localStorage.remove('eeTotalEarnings')
              this._localStorage.remove('analyticsData')
              const apiData = ((response || {}).data || {});
              this.analyticsData = [
                {
                  id: 'rec_earning',
                  name: 'rec earning',
                  value: apiData.earning_by_rec || 0,
                },
               {
                  id: 'qr_earning',
                  name: 'qr earning',
                  value: apiData.extra_earning_by_qr || 0,
                },
                {
                  id: 'loyalty_earning',
                  name: 'loyalty earning',
                  value: apiData.earning_by_loyalty || 0,
                },
              ];
              this.eeTotalEarnings = this.analyticsData.reduce(
                (total, obj) => total + (obj.value || 0),
                0
              );
              this._localStorage.set('eeTotalEarnings',this.eeTotalEarnings.toString())
              this._localStorage.set('analyticsData', JSON.stringify(this.analyticsData))
              this._localStorage.set(
                'lastExecutionDate',
                new Date().toISOString().slice(0, 10)
              );
            }else{
              this.analyticsData = []
            }
          this._cdr.detectChanges()
          },
          (error) => {
            console.log(error);
          }
        );
    }else{
      this.eeTotalEarnings = +this._localStorage.get('eeTotalEarnings')
      this.analyticsData = JSON.parse(this._localStorage.get('analyticsData'))
    }
  }

  acknowledgePendingWarn() {
    this._tbApiService.acknowledgePendingWarn().subscribe(
      (res: any) => {},
      (error) => {}
    );
  }

  closeTableBookWarnPopup(neverRemind: boolean = false) {
    this.showResvWarnPopup = false;
    if (neverRemind) {
      this.acknowledgePendingWarn();
      this.updateNeverRemindBookingPending();
    }
  }

  openTableBooking() {
    this.router.navigate(['/table-bookings'], {
      queryParams: { fromPopup: true },
    });
    this.showResvWarnPopup = false;
    this.acknowledgePendingWarn();
  }

  updateNeverRemindBookingPending() {
    const restaurant_id = this._localStorage.get('restaurant_id');
    const timezone = this._localStorage.get('time_zone');
    const endOfDayEpochSeconds = dayjs().tz(timezone).endOf('day').unix();
    const payload = {
      restaurant_id: restaurant_id,
      settings: {
        global: {
          booking_no_remind_till: endOfDayEpochSeconds,
        },
      },
    };
    this.apiService.updateRestaurantSettings(payload).subscribe(
      (response: any) => {},
      (error) => {}
    );
  }

}
